import { render, staticRenderFns } from "./SpendingCategory.vue?vue&type=template&id=27be5863&scoped=true&"
import script from "./SpendingCategory.vue?vue&type=script&lang=js&"
export * from "./SpendingCategory.vue?vue&type=script&lang=js&"
import style0 from "./SpendingCategory.vue?vue&type=style&index=0&id=27be5863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27be5863",
  null
  
)

export default component.exports